import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import NotificationIcon from 'src/assets/icons/NotificationIcon';
import BackIcon from 'src/assets/images/icons/BackIcon';
import APP_ROUTES from 'src/layout/Routes';
import { NotificationLink } from '../NotificationsLink';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useDispatch } from 'react-redux';
import { addClickstreamEvent } from '../../service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '../../service/clickStream.constant';
import HistoryIcon from 'src/assets/icons/HistoryIcon';
import CaseHistory from '../CaseHistory/CaseHistory';
import AutoComplete from '../GlobalSearch/AutoComplete';
import cx from 'classnames';
import {
  setCurrentRecommendedCase,
  setRecommendedCases
} from '@cp/src/pages/CaseRecommendation/reducer';
interface ITopNavbarProps {
  isDc97User?: boolean;
  isAgentDashboard?: boolean;
  isAmeyoGeneratePasswordPage?: boolean;
}

export const NOT_SHOW_AUTOCOMPLETE_ROUTES = [
  APP_ROUTES.GENERATE_AMEYO_PASSWORD.path,
  APP_ROUTES.DASHBOARD.path,
  APP_ROUTES.PERFORMANCE_DASHBOARD.path
];

const TopNavBar = ({
  isDc97User,
  isAgentDashboard,
  isAmeyoGeneratePasswordPage
}: ITopNavbarProps) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showCaseHistory, setShowCaseHistory] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentPath = useLocation().pathname;
  const isCasesListingPage = useLocation().pathname === APP_ROUTES.CASES.path;
  const hideForTLCase = useLocation().pathname === APP_ROUTES.TEAM_LEAD_DASHBOARD.path;
  const isLonghornThemeEnabled = useSelector(
    (state: RootState) => state.common.isLonghornThemeEnabled
  );
  const isPerformanceDashboardVisible = useSelector(
    (state: RootState) => state.common.isPerformanceDashboardVisible
  );
  const enableAnomalyTracker = useSelector(
    (state: RootState) => state.common.featureFlags?.enableAnomalyTracker
  );
  const isTeamLead = useSelector((state: RootState) => state.common.isTeamLead);
  const isCiuAgent = useSelector((state: RootState) => state.common.isCiuAgent);

  const navigateToCases = useCallback(() => {
    let url: string;
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_CaseDetails_BackButtonClick);
    if (isTeamLead) {
      url = (
        document.getElementById(APP_ROUTES.TEAM_LEAD_DASHBOARD.path) as HTMLAnchorElement
      ).href.split(APP_ROUTES.TEAM_LEAD_DASHBOARD.path)[1];
      return navigate(`${APP_ROUTES.TEAM_LEAD_DASHBOARD.path}${url}`);
    }

    url = (document.getElementById(APP_ROUTES.CASES.path) as HTMLAnchorElement)?.href?.split(
      APP_ROUTES.CASES.path
    )[1];
    navigate(APP_ROUTES.CASES.path + `${url}`);
    dispatch(setRecommendedCases({ cases: [] }));
    dispatch(setCurrentRecommendedCase({ currentRecommendedCase: null }));
  }, [isTeamLead]);

  const toggleNotifications = (show: boolean) => {
    setShowNotifications(show);
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_Notifications_BellIconClick, {
      clickedFromPage: currentPath
    });
  };

  const toggleCaseHistory = (show: boolean) => {
    setShowCaseHistory(show);
  };

  const hideBackButton =
    isCasesListingPage ||
    isDc97User ||
    isAgentDashboard ||
    hideForTLCase ||
    isAmeyoGeneratePasswordPage;
  const showTopNavItems = !isDc97User && !isPerformanceDashboardVisible && !isTeamLead;
  const showAutoComplete = !isDc97User && !NOT_SHOW_AUTOCOMPLETE_ROUTES.includes(currentPath);
  const showNotificationsIcon = (showTopNavItems || enableAnomalyTracker) && !isCiuAgent;

  return (
    <div
      className={cx({
        [styles.topNavContainer]: true,
        ['bg-[var(--bg-primary-warm)]']: !isLonghornThemeEnabled
      })}
    >
      {hideBackButton ? null : (
        <div className={styles.navigate} onClick={navigateToCases}>
          <BackIcon className={styles.icon} size={'16'} />
        </div>
      )}
      <div
        className={cx({
          [styles.iconsContainer]: true,
          ['!top-[15px] !right-[6px]']: isLonghornThemeEnabled && isTeamLead
        })}
      >
        {showAutoComplete ? (
          <div className={styles.globalSearchContainer}>
            <AutoComplete />
          </div>
        ) : null}
        {showTopNavItems ? (
          <>
            <div
              className={styles.caseHistoryContainer}
              onClick={() => toggleCaseHistory(!showCaseHistory)}
            >
              <div className={styles.caseHistory}>
                <HistoryIcon />
              </div>
            </div>
            <CaseHistory
              toggleCaseHistory={toggleCaseHistory}
              showCaseBrowsingHistory={showCaseHistory}
            />
          </>
        ) : null}
        {showNotificationsIcon ? (
          <>
            <div
              className={styles.notifContainer}
              onClick={() => toggleNotifications(!showNotifications)}
            >
              <div className={styles.notif}>
                <NotificationIcon />
              </div>
            </div>
            <NotificationLink
              toggleNotifications={toggleNotifications}
              showNotifications={showNotifications}
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default TopNavBar;
